module.exports = __webpack_public_path__ + "static/media/loading.d3b1b845.gif";